import {nextId} from './id_helper'
import IndexArray from 'index-array'
import _ from 'lodash'

window.IndexArray = IndexArray


function decorateArrays(obj, nested = true) {
  let result = obj

  if (_isObject(obj)) {
    for (let key in obj) {
      obj[key] = decorateArrays(obj[key])
    }
  }

  if (Array.isArray(obj)) {
    for (let i=0; i<obj.length; i++) {
      obj[i] = decorateArrays(obj[i])
    }
  }


  if (Array.isArray(obj) && !(obj instanceof IndexArray)) {
    result = new IndexArray(...obj)
  }

  return result
}


function decorateUids(obj, nested = true) {

  if (Array.isArray(obj)) {
    obj.forEach((item) => {
      if (_isObject(item) && !item.uid) {
        item.uid = nextId()
      }
    })
  }

  if (obj instanceof Object && nested) {
    for (let key in obj) {
      decorateUids(obj[key], nested)
    }
  }

  return obj
}


function decorateFull(obj, nested = true) {
  return decorateArrays(decorateUids(obj, nested), nested)
}


function _isObject(obj) {
  return obj instanceof Object && !Array.isArray(obj)
}

function arrayToObject(arr) {
  let result = {}
  arr.forEach((item) => {
    result[item.key] = item.value
  })
  return result
}

function objectToArray(obj) {
  return _.map(obj, (value, key) => {
    return {key, value}
  })
}

const EXTRACT_ARRAY_SKIP_KEYS = new Set(['error', 'errors'])

// Breadth-frist search of an object to find the first array for non-array API responses
function extractArray(data) {
  if (Array.isArray(data)) return data

  const queue = [data]

  while (queue.length > 0) {
    const node = queue.shift()
    if (!node || typeof node !== 'object' || Array.isArray(node)) continue

    for (const [key, value] of Object.entries(node)) {
      if (EXTRACT_ARRAY_SKIP_KEYS.has(key)) continue
      if (Array.isArray(value)) return value
      if (value && typeof value === 'object') queue.push(value)
    }
  }

  return []
}

export {decorateArrays, decorateUids, decorateFull, arrayToObject, objectToArray, extractArray}